/* ==========================================================================
   BOUNTEOUS CONFIDENTIAL
   ___________________

   Copyright 2019 Bounteous
   All Rights Reserved.

   NOTICE:  All information contained herein is, and remains the property
   of Bounteous and its suppliers, if any. The intellectual and
   technical concepts contained herein are proprietary to Bounteous
   and its suppliers and are protected by trade secret or copyright law.
   Dissemination of this information or reproduction of this material
   is strictly forbidden unless prior written permission is obtained
   from Bounteous.
   ========================================================================== */

/**
 * Base Component Class
 */
export class Component {
    /** @param {Element} element */
    constructor(element) {
        this.element = element;
    }

    init() {
        //eslint-disable-next-line no-console
        console.warn("Component class init() method expected to be overridden - maybe we don't need to inherit from Component class?", this.element);
    }
}

/**
 * Register Component Function
 * @param {string} selector - querySelectorAll string ie. '.component'
 * @param {typeof Component} ComponentClass - class to pass component selector to ie. Component
 */
export function registerComponent(selector, ComponentClass) {
    const componentGroup = document.querySelectorAll(selector);
    componentGroup.forEach((element) => {
        try {
            new ComponentClass(element).init();
        } catch (error) {
            //eslint-disable-next-line no-console
            console.warn('Error initializing component:', element, error);
        }
    });
}
